export default defineNuxtRouteMiddleware(() => {
  const { isAuthenticated } = useAuth()

  if (isAuthenticated.value) {
    const { query } = useRoute()
    const redirectTo = String(query.redirect)
    return navigateTo(redirectTo ?? { name: 'index' })
  }
})
